var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'sidebar-collapsed': _vm.isCollapsed },style:(_vm.appStyle),attrs:{"id":"app"}},[_c('TheSidebar',{on:{"toggle":_vm.onSidebarToggle}}),_c('main',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }